<div #map
     [style.height]="height"
     [style.width]="width"></div>
